import { Link } from 'features/i18n/router'
import { ROUTE_PATH } from 'lib/paths'
import { Post } from 'lib/_types'

import './style.scss'

export const PostBreadcrumb = ({ post }: { post: Post }) => {
  const threadId = post?.thread_id || post?.thread?.id
  const groupId = post?.group_id || post?.group?.id
  if (!threadId && !groupId) return null

  const groupTopic = post?.group?.topic

  return (
    <div className="PostBreadcrumb">
      {threadId && (
        <Link to={ROUTE_PATH.GROUP_THREAD(groupId, threadId)}>
          <img
            src="/images/icon-post-thread-header-balloon.svg"
            alt="Chat balloon"
          />
          <p>{post?.thread?.title}</p>
        </Link>
      )}
      {groupId && groupTopic && (
        <Link to={ROUTE_PATH.GROUP(groupId)}>
          {threadId ? (
            `(${groupTopic})`
          ) : (
            <>
              <img src="/images/header-ul-a-circle.svg" alt="Circle" />
              <p>{groupTopic}</p>
            </>
          )}
        </Link>
      )}
    </div>
  )
}
